export const DURATION_UNITS = {
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days',
};

export const FILE_ICONS = {
  png: 'i-ri-image-line',
  jpg: 'i-ri-image-line',
  jpeg: 'i-ri-image-line',
  gif: 'i-ri-image-line',
  webp: 'i-ri-image-line',
  mp4: 'i-ri-file-video-line',
  webm: 'i-ri-file-video-line',
  pdf: 'i-ri-file-pdf-2-line',
  doc: 'i-ri-file-word-line',
  docx: 'i-ri-file-word-line',
  csv: 'i-ri-file-excel-line',
};
